module.exports = __webpack_public_path__ + "img/builder-17.b8dbb9ee.jpg";